import {handleActions} from 'redux-actions';
import {actions} from './actions';
import {reducers as _reducers} from './reducers';


const defaultState = {
    api: {
        init:false,
        code:null,
        isMobile:false,
        searchType: 'both',
        error: false
    }
};


const reducers = handleActions(new Map([
    ..._reducers
]), defaultState);

export {
    actions, reducers
};
